import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ta',
    fullName: 'Tamil',
    nativeName: 'தமிழ்',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "ஏதோ அற்புதம் வருகிறது",
    landing_subtitle: "ArgVoid என்பது ஒரு பயன்பாடு மற்றும் விளையாட்டு மேம்பாட்டு ஸ்டுடியோ ஆகும். காத்திருங்கள், புதிய விஷயங்கள் விரைவில் வரும்!",
    select_language: "மொழியைத் தேர்ந்தெடுக்கவும்",
    search_placeholder: "மொழிகளைத் தேடு...",
    terms_title: "சேவை விதிமுறைகள்",
    policy_title: "தனியுரிமைக் கொள்கை",
    cookies_title: "குக்கீ கொள்கை",
    terms_content: `
        <strong>1. விதிமுறைகளை ஏற்றுக்கொள்வது</strong><br>
        ArgVoid ஐ அணுகுவதன் மூலம், இந்த சேவை விதிமுறைகள் ஏற்கப்படுகின்றன. இந்த விதிமுறைகள் ஏற்றுக்கொள்ளப்படாவிட்டால், சேவையைப் பயன்படுத்தக்கூடாது.<br><br>

        <strong>2. இயங்குதள பயன்பாடு</strong><br>
        ArgVoid மற்றும் அதன் பயன்பாடுகள் தகவல் மற்றும் ஆக்கப்பூர்வமான நோக்கங்களுக்காக "உள்ளபடியே" வழங்கப்படுகின்றன. சேவையானது சட்டப்பூர்வ நோக்கங்களுக்காக மட்டுமே பயன்படுத்தப்பட வேண்டும்.<br><br>

        <strong>3. தடைசெய்யப்பட்ட நடத்தை</strong><br>
        தளத்தின் பாதிப்புகளைப் பயன்படுத்துதல், ஸ்பேமிங் செய்தல் அல்லது உள்கட்டமைப்பிற்கு அங்கீகரிக்கப்படாத அணுகலை முயற்சிப்பது கண்டிப்பாக தடைசெய்யப்பட்டுள்ளது.<br><br>

        <strong>4. மறுப்பு</strong><br>
        தளம் மற்றும் சேவைகள் எந்த நேரத்திலும் அறிவிப்பு இல்லாமல் மாற்றப்படலாம். சேவையின் நேரம் அல்லது கிடைக்கும் தன்மை குறித்து எந்த உத்தரவாதமும் வழங்கப்படவில்லை.
    `,
    policy_content: `
        <strong>1. தகவல் சேகரிப்பு</strong><br>
        இயங்குதளத்திற்கு இந்த நேரத்தில் பயனர் அங்கீகாரம் அல்லது கணக்கு உருவாக்கம் தேவையில்லை. பார்வையாளர்களிடமிருந்து தனிப்பட்ட அடையாளம் காணும் தகவல் (பெயர்கள் அல்லது மின்னஞ்சல் முகவரிகள் போன்றவை) தீவிரமாக சேகரிக்கப்படவில்லை.<br><br>

        <strong>2. பயன்பாட்டு தரவு</strong><br>
        தளத்தின் போக்குவரத்தைப் புரிந்துகொள்வதற்கும் பயன்பாடுகளை மேம்படுத்துவதற்கும் அடிப்படை, அநாமதேய பகுப்பாய்வுகள் சேகரிக்கப்படலாம். இந்தத் தரவு தனிப்பட்ட பயனர் அடையாளங்களுடன் இணைக்கப்படவில்லை.<br><br>

        <strong>3. மூன்றாம் தரப்பு சேவைகள்</strong><br>
        ஹோஸ்டிங் மற்றும் பகுப்பாய்வு சேவைகளுக்கு மூன்றாம் தரப்பு வழங்குநர்கள் பயன்படுத்தப்படலாம். இந்த தொடர்புடைய வழங்குநர்களின் தனியுரிமை நடைமுறைகள் அவர்களின் உள்கட்டமைப்பில் செயலாக்கப்பட்ட அநாமதேய தரவை நிர்வகிக்கிறது.<br><br>

        <strong>4. தரவு பாதுகாப்பு</strong><br>
        தளத்தைப் பாதுகாக்க நியாயமான பாதுகாப்பு நடவடிக்கைகள் செயல்படுத்தப்படுகின்றன. இருப்பினும், இணையத்தில் அனுப்பும் எந்த முறையும் முற்றிலும் பாதுகாப்பானது அல்ல.<br><br>
    `,
    cookies_content: `
        <strong>1. குக்கீகள் மற்றும் உள்ளூர் சேமிப்பகம் என்றால் என்ன?</strong><br>
        குக்கீகள் மற்றும் உலாவி உள்ளூர் சேமிப்பகம் ஆகியவை, வருகைகள் முழுவதும் உள்ளமைவு விருப்பத்தேர்வுகளை நினைவில் வைக்க, சாதனத்தில் சேமிக்கப்படும் சிறிய தரவுக் கோப்புகள்.<br><br>

        <strong>2. பயன்பாட்டு நோக்கம்</strong><br>
        உள்ளமைவு அமைப்புகளைச் சேமிக்க உலாவி லோக்கல் ஸ்டோரேஜ் கண்டிப்பாகப் பயன்படுத்தப்படுகிறது, அதாவது:<br>
        - மொழி விருப்பத்தேர்வுகள்<br>
        - பயனர் இடைமுக கட்டமைப்பு (எ.கா., தளவமைப்பு அல்லது தீம் அமைப்புகள்)<br>
        - தற்காலிக பயன்பாட்டு கேச்<br><br>

        <strong>3. ட்ராக்கிங்</strong><br> இல்லை
        குக்கீகளும் உள்ளூர் சேமிப்பகமும் விளம்பரம் அல்லது மூன்றாம் தரப்பு கண்காணிப்பு நோக்கங்களுக்காகப் பயன்படுத்தப்படுவதில்லை. சேமிக்கப்பட்ட தரவு அனைத்தும் இயங்குதளத்தின் முக்கிய செயல்பாட்டிற்காக கண்டிப்பாக உள்ளது.<br><br>

        <strong>4. கண்ட்ரோல்</strong><br>
        உலாவி அமைப்புகளின் மூலம் எந்த நேரத்திலும் உலாவி தரவை அழிக்க முடியும், இது எந்த உள்ளூர் உள்ளமைவுகளையும் மீட்டமைக்கும்.
    `,
    cookie_consent_text: "உங்கள் அமர்வை செயலில் வைத்திருப்பது, உங்கள் மொழி விருப்பம் மற்றும் பிற தனிப்பயன் உள்ளமைவுகளைச் சேமிப்பது போன்ற இணையதளச் செயல்பாடுகளைச் சரியாக உறுதிப்படுத்த அடிப்படை குக்கீகளைப் பயன்படுத்துகிறோம்.",
    read_policy: "குக்கீ கொள்கையைப் படிக்கவும்",
    support_title: "ஆதரவைத் தொடர்பு கொள்ளவும்",
    support_subject_label: "பொருள்",
    support_message_label: "செய்தி",
    support_submit_button: "செய்தி அனுப்பு",
    support_hint: "குறிப்பு: இது செய்தியை அனுப்ப உங்கள் இயல்புநிலை மின்னஞ்சல் பயன்பாட்டைத் திறக்கும்.",
    support_success_msg: "உங்கள் மின்னஞ்சல் பயன்பாட்டைத் திறக்கிறது...",
    support_error_msg: "செய்தியை அனுப்ப முடியவில்லை. பிறகு முயற்சிக்கவும்.",
    explorer_title: "எக்ஸ்ப்ளோரர்",
    history_title: "வரலாறு",
    animation_title: "அனிமேஷன்",
    config_title: "கட்டமைப்பு",
    tool_mouse: "தேர்ந்தெடு (Ctrl+M)",
    tool_brush: "தூரிகை (Ctrl+B)",
    tool_brush_mode: "நிலைமாற்று பயன்முறை (திட/தெளிவான)",
    tool_eraser: "அழிப்பான் (Ctrl+E)",
    tool_brush_size: "தூரிகை அளவை சரிசெய்யவும்",
    tool_bucket: "நிரப்பு (Ctrl+F)",
    tool_eyedropper: "கண்துளிர்",
    tool_grid: "கட்டம் (Ctrl+Shift+B)",
    tool_rotate: "சுழற்று (Ctrl+Shift+R)",
    tool_flip_h: "Flip H (Ctrl+Shift+H)",
    tool_flip_v: "Flip V (Ctrl+Shift+V)",
    tool_transpose: "இடமாற்றம் (Ctrl+Shift+T)",
    label_width: "அகலம்",
    label_height: "உயரம்",
    label_frames: "பிரேம்களின் எண்ணிக்கை",
    label_animation: "அனிமேஷன் ஸ்டைல்",
    label_background_color: "பின்னணி நிறம்",
    label_interval: "இடைவெளி",
    tool_anim_config: "அனிமேஷன் கட்டமைப்பு",
    label_new_width: "புதிய அகலம்",
    label_new_height: "புதிய உயரம்",
    label_apply: "விண்ணப்பிக்கவும்",
    label_colors: "நிறங்கள்",
    label_size: "அளவு",
    label_tolerance: "சகிப்புத்தன்மை",
    val_horizontal: "கிடைமட்ட",
    val_vertical: "செங்குத்து",
    val_sequence: "வரிசை",
    val_bounce: "துள்ளல்",
    val_random: "சீரற்ற",
    val_solid: "திடமான",
    val_clear: "தெளிவு",
    action_add_sheet: "புதிய தாள்",
    action_import: "இறக்குமதி",
    action_export: "ஏற்றுமதி",
    action_sort_projects: "வரிசைப்படுத்து",
    sort_date_old: "பழமையான முதல்",
    sort_date_new: "புதியது முதலில்",
    sort_name_az: "பெயர் (A-Z)",
    sort_name_za: "பெயர் (Z-A)",
    action_new_sprite: "புதிய ஸ்பிரைட்",
    action_new_project: "புதிய திட்டம்",
    modal_save_all_title: "அனைத்து மாற்றங்களையும் சேமிக்கவும்",
    modal_save_all_desc: "சேமிக்க சொத்துகளைத் தேர்ந்தெடுக்கவும்:",
    modal_save_selected: "தேர்ந்தெடுக்கப்பட்டதை சேமிக்கவும்",
    action_saved: "சேமிக்கப்பட்டது",
    modal_create_sprite_title: "புதிய ஸ்பிரைட்டை உருவாக்கவும்",
    modal_create_project_title: "புதிய திட்டத்தை உருவாக்கவும்",
    modal_add_sheet_title: "புதிய தாளைச் சேர்க்கவும்",
    modal_rename_sheet_title: "தாளை மறுபெயரிடவும்",
    modal_rename_sprite_title: "ஸ்ப்ரைட்டின் பெயரை மாற்றவும்",
    modal_delete_sprite_title: "ஸ்ப்ரைட்டை நீக்கு",
    modal_delete_project_title: "திட்டத்தை நீக்கு",
    modal_delete_sheet_title: "தாளை நீக்கு",
    placeholder_sprite_name: "பெயர்",
    placeholder_project_name: "பெயர்",
    placeholder_sheet_name: "பெயர்",
    placeholder_new_name: "புதிய பெயர்",
    action_create: "உருவாக்கு",
    action_add: "சேர்",
    action_rename: "மறுபெயரிடவும்",
    action_duplicate: "நகல்",
    action_delete: "நீக்கு",
    action_cancel: "ரத்து செய்",
    confirm_delete_sprite: "இந்த ஸ்பிரைட்டை நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
    confirm_delete_project: "இந்தத் திட்டத்தை நிச்சயமாக நீக்க விரும்புகிறீர்களா? அனைத்து உருவங்களும் அகற்றப்படும்.",
    confirm_delete_sheet: "இந்தத் தாளை நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
    err_select_sprite: "முதலில் ஒரு ஸ்பிரிட்டைத் தேர்ந்தெடுக்கவும்.",
    err_select_project: "முதலில் ஒரு திட்டத்தைத் தேர்ந்தெடுக்கவும்.",
    err_name_empty: "பெயர் காலியாக இருக்கக்கூடாது.",
    err_sprite_exists: "அந்த பெயரில் ஒரு ஸ்பிரைட் ஏற்கனவே உள்ளது.",
    err_project_exists: "அந்த பெயரில் ஒரு திட்டம் ஏற்கனவே உள்ளது.",
    err_no_content: "சேமிக்க உள்ளடக்கம் இல்லை.",
    err_no_changes: "சேமிக்க எந்த மாற்றமும் இல்லை.",
    err_delete_last_sheet: "கடைசி தாளை நீக்க முடியாது.",
    err_extract_frames: "எந்த சட்டகத்தையும் பிரித்தெடுக்க முடியவில்லை.",
    err_indexeddb: "உள்ளூரில் சேமிக்க முடியவில்லை. உங்கள் உலாவி IndexedDB ஐ ஆதரிக்காமல் இருக்கலாம்.",
    msg_upload_success: "பதிவேற்றம் வெற்றியடைந்தது: {0}",
    msg_upload_failed: "பதிவேற்றம் தோல்வியடைந்தது: {0}",
    msg_save_success: "வெற்றிகரமாக சேமிக்கவும்.",
    msg_saving: "சேமிக்கிறது...",
    msg_multi_save_result: "{0} சொத்துக்கள் சேமிக்கப்பட்டன. {1} தோல்விகள்.",
    menu_title: "மெனு",
    menu_save: "சேமிக்கவும்",
    menu_save_all: "அனைத்தையும் சேமிக்கவும்",
    menu_support: "ஆதரவைத் தொடர்பு கொள்ளவும்",
    label_local_storage: "உள்ளூர் சேமிப்பு",
    label_sign_in: "உள்நுழையவும்",
    modal_export_title: "ஏற்றுமதி ஸ்ப்ரைட்",
    label_filename: "கோப்பு பெயர்",
    label_format: "வடிவம்",
    action_export_confirm: "ஏற்றுமதி",
};

export default translations;
